import {
	get,
	put,
	post,
	deletes,
	axiosErrorHandler,
} from 'models/shared/helpers/axiosInstance';
import { VehicleDetailImagesType } from '../enums/vehicle-detail.enum';
import {
	CreateVehicleDetailDto,
	UpdateVehicleDetailDto,
	VehicleDetail,
} from '../interfaces/vehicle-detail.interface';

const basePath = '/v1/vehicle-details';

export const createVehicleDetails = async (dto: CreateVehicleDetailDto) => {
	try {
		const res = await post<VehicleDetail>(basePath, dto);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const getVehicleDetails = async () => {
	try {
		const res = await get<VehicleDetail[]>(basePath);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const getVehicleDetailsBySkuId = async (skuId: string) => {
	try {
		const res = await get<VehicleDetail>(`${basePath}/by-sku/${skuId}`);
		return res.data;
	} catch (err) {
		return null;
	}
};

export const getVehicleDetailsById = async (id: string) => {
	try {
		const res = await get<VehicleDetail>(`${basePath}/${id}`);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const updateVehicleDetails = async (
	id: string,
	dto: UpdateVehicleDetailDto,
) => {
	try {
		const res = await put<VehicleDetail>(`${basePath}/${id}`, dto);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const addFileVehicleDetail = async (
	id: string,
	imageType: VehicleDetailImagesType,
	file: File,
) => {
	try {
		const data = new FormData();
		data.append('name', file.name);
		data.append('file', file);
		const res = await put<VehicleDetail>(
			`${basePath}/${id}/images/${imageType}`,
			data,
			{ headers: { 'Content-Type': 'multipart/form-data' } },
		);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const deleteFileVehicleDetail = async (id: string, imageId: string) => {
	try {
		const res = await deletes<VehicleDetail>(
			`${basePath}/${id}/images/${imageId}`,
		);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};
